
import { defineComponent } from 'vue'
import YieldRow from '../../form/bond/YieldRow.vue'
import { mapActions, mapState } from 'vuex'
import { ActionTypes } from '../../../store'

interface RowPayload {
  row: number;
  name: string;
  value: string;
}

export default defineComponent({
  name: 'YieldFormNew',
  components: {
    YieldRow
  },
  data () {
    return {
      numRows: 3,
      formset: [] as Record<string, string | boolean>[],
      results: {
        yields: [],
        total: 0
      },
      originalResults: {
        yields: [],
        total: 0
      },
      adjustedResults: {
        yields: [],
        total: 0
      },
      apiErrors: undefined,
      targetTotal: null as number | null
    }
  },
  computed: {
    ...mapState(['products']),
    hasAnyAdjustments(): boolean {
      if (!this.adjustedResults.yields || this.adjustedResults.yields.length === 0) return false
      return this.adjustedResults.yields.some((result: any) => result.is_adjusted || result.delta_applied)
    }
  },
  methods: {
    ...mapActions({
      fetchProducts: ActionTypes.FETCH_PRODUCTS_D,
      submitYields: ActionTypes.SUBMIT_YIELD_CALC
    }),
    rowUpdate (rowPayload: RowPayload) {
      const newFormset = [...this.formset]
      newFormset[rowPayload.row][rowPayload.name] = rowPayload.value
      this.formset = newFormset
      console.log(this.formset)
    },
    calculateYield (isAdjustment: boolean = false) {
      // Filter out empty rows
      const validRows = this.formset.filter((row) => row.product !== '0')

      if (validRows.length > 0) {
        const payload = validRows.map(row => {
          const basePayload: any = {
            product: parseInt(String(row.product)),
            ratio: parseFloat(String(row.ratio)) || 0,
            price: parseFloat(String(row.price)) || 0
          }

          // If this is an adjustment and row is selected, apply delta
          if (isAdjustment && (row.select_for_adjustment === 'true' || row.select_for_adjustment === true)) {
            basePayload.apply_delta = true
            // DON'T use || 0 here - it will override negative values!
            basePayload.yield_delta = parseFloat(String(row.yield_delta))
          } else {
            basePayload.apply_delta = false
          }

          return basePayload
        })

        console.log('Sending payload:', payload)

        this.submitYields(payload).then((result) => {
          if (!isAdjustment) {
            // Initial calculation - store as both original and current results
            this.originalResults = JSON.parse(JSON.stringify(result))
            this.results = result
          } else {
            // Adjustment calculation - store separately, don't update main results
            this.adjustedResults = result
          }
        }).catch((error) => this.apiErrors = error.response.data)
      }
    },
    applyDeltaAdjustment() {
      console.log('Apply Delta Adjustment clicked')
      console.log('Target Total:', this.targetTotal)
      console.log('Current Total:', this.results.total)

      // Validation checks
      if (!this.results.yields || this.results.yields.length === 0) {
        alert('Please calculate yields first before adjusting')
        return
      }

      if (this.targetTotal === null || this.targetTotal === undefined) {
        alert('Please enter a target total value')
        return
      }

      const currentTotal = this.results.total
      const targetTotal = this.targetTotal
      const deltaTotal = targetTotal - currentTotal

      console.log('Delta Total:', deltaTotal)

      // Update formset with calculated delta
      const newFormset = [...this.formset]
      let validRowIndex = 0

      newFormset.forEach((row, formsetIndex) => {
        if (row.product !== '0') {
          // This is a valid row
          if (row.select_for_adjustment === 'true' || row.select_for_adjustment === true) {
            let delta: number

            if (validRowIndex === 0) {
              // First leg adds to total
              delta = deltaTotal
            } else {
              // Other legs subtract from total
              delta = -deltaTotal
            }

            row.yield_delta = String(delta)
            console.log(`Setting yield_delta for row ${formsetIndex} (validIndex ${validRowIndex}): ${delta}`)
          }
          validRowIndex++
        }
      })

      this.formset = newFormset
      console.log('Updated formset:', this.formset)

      // Recalculate with delta
      this.calculateYield(true)
    },
    initRows () {
      this.formset = [...Array(this.numRows).keys()].map(() => { return this.emptyRow() })
      this.results = {
        yields: [],
        total: 0
      }
      this.originalResults = {
        yields: [],
        total: 0
      }
      this.adjustedResults = {
        yields: [],
        total: 0
      }
      this.targetTotal = null
    },
    emptyRow (): Record<string, string | boolean> {
      return {
        product: '0',
        price: '0',
        ratio: '0',
        select_for_adjustment: false,
        yield_delta: '0'
      }
    },
    getProductName(productId: string): string {
      if (!productId || productId === '0') return '-'
      const product = this.products.find((p: any) => p.id === parseInt(productId))
      return product ? product.name : '-'
    },
    async copyCurrentTotal() {
      const totalValue = this.results.total ? this.results.total.toFixed(3) : '0'
      try {
        await navigator.clipboard.writeText(totalValue)
      } catch (err) {
        const textArea = document.createElement('textarea')
        textArea.value = totalValue
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('copy')
        document.body.removeChild(textArea)
      }
    }
  },
  created () {
    this.fetchProducts()
    this.initRows()
  }

})
